:host {
  height: 100%;
  width: 100%;
  background-color: transparent;
}

.customer-overview {
  display: grid;

  @include mobile {
    grid-template-columns: repeat(1, minmax(0, max-content));
  }
  @include tablet {
    grid-template-columns: repeat(2, minmax(0, max-content));
  }
  @include desktop {
    grid-template-columns: repeat(2, minmax(0, max-content));
  }
  overflow-wrap: anywhere;
  row-gap: $xp-ref-spacing-2;
  column-gap: 8px;
  justify-self: flex-start;
  text-align: left;
  font: $xp-ref-font-label-label-short;

  .item:nth-child(odd) {
    color: $xp-ref-color-text-forms-label;
  }
  .item:nth-child(even) {
    color: $xp-ref-color-text-default-dark;
  }
}
